<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-12 mb-2">
              <label for="idusuario">Usuario</label>
              <div class="d-flex">
                <input class="form-control" formControlName="idusuario" id="idusuario" type="text">
                <button (click)="searchUser()" [disabled]="agregarForm.controls['idusuario'].errors" class="btn btn-success" type="button">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <small
                *ngIf="agregarForm.controls['idusuario'].errors && agregarForm.controls['idusuario'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="garita">Garita</label>
              <select class="form-control" formControlName="garita">
                <option value="0">-- Seleccione --</option>
                <option *ngFor="let gar of garitaSelect" [value]="gar.idGarita">{{gar.desca}}</option>
              </select>
              <small
                *ngIf="agregarForm.controls['garita'].errors && agregarForm.controls['garita'].touched"
                class="text-danger">*Este campo es inválido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label for="bascula">Báscula</label>
              <select class="form-control" formControlName="bascula" id="bascula" name="bascula">
                <option value="0">-- Seleccione --</option>
                <option *ngFor="let bas of basculaSelect" [value]="bas.idBascula">{{bas.desca}}</option>
              </select>
              <small *ngIf="agregarForm.controls['bascula'].errors && agregarForm.controls['bascula'].touched" class="text-danger">*Este campo es inválido</small>
            </div>
            
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-lg-12 mb-2 position-relative">
            <label for="usuarioDescripcion" style="visibility: hidden;">A</label>
            <div class="d-flex">
              <input class="form-control" formControlName="usuarioDescripcion" id="usuarioDescripcion"
                     type="text">
              <button (click)="searchUsers()" class="btn btn-success" type="button">
                <i class="fa fa-bars"></i>
              </button>
            </div>
            <div *ngIf="showUsers" class="combo-box-custom shadow">
              <!--<div (click)="selectedUser(cmb)"
                   *ngFor="let cmb of cmbUsuarios | searchCmbBox:agregarForm.get('usuarioDescripcion').value"
                   class="px-3 py-2">{{cmb.login}} - {{cmb.nombre}}</div>
            -->
            <div (click)="selectedUser(cmb)"
                   *ngFor="let cmb of cmbUsuarios"
                   class="px-3 py-2">{{cmb.login}} - {{cmb.nombre}}</div>
            </div>
          </div>

          <div class="col-lg-12 mb-2">
            <label for="garitaDescripcion" style="visibility: hidden;">A</label>
            <input class="form-control" formControlName="garitaDescripcion" id="garitaDescripcion"
                   type="text">
          </div>

          <div class="col-lg-12 mb-2">
            <label for="basculaDescripcion" style="visibility: hidden;">A</label>
            <input class="form-control" formControlName="basculaDescripcion" id="basculaDescripcion"
                   type="text">
          </div>
        </div>
        <div class="mb-3">
          <label for="tipoBloqueo">Desbloqueos</label>
          <select class="form-control" formControlName="tipoBloqueo">
            <option value="NINGUNO">-- Seleccione --</option>
            <option value="1">Desbloqueos de Calidad</option>
            <option value="2">Desbloqueos de Pesos</option>
          </select>
        </div>
        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                     [loading]="loading" [textBoton]="'Guardar'"
                                     class="row">
        </app-lfsa-botones-formulario>
      </div>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
